module.exports = __webpack_public_path__ + "img/cloud-upload.7e869501.svg";